var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_6096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.684 2.81934H241.348C109.672 2.81934 2.97168 116.198 2.97168 256.001C2.97168 395.804 109.672 509.182 241.348 509.182H270.684C402.36 509.182 509.06 395.804 509.06 256.001C509.06 116.198 402.36 2.81934 270.684 2.81934Z",
    fill: "#CD7D0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.668 512H241.332C108.252 512 0 397.142 0 256C0 114.858 108.252 0 241.332 0H270.668C403.748 0 512 114.858 512 256C512 397.142 403.748 512 270.668 512ZM241.332 5.63721C111.504 5.63721 5.91139 117.959 5.91139 256C5.91139 394.041 111.504 506.363 241.332 506.363H270.668C400.496 506.363 506.089 394.041 506.089 256C506.089 117.959 400.496 5.63721 270.668 5.63721H241.332Z",
    fill: "#AB6004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.03 427.447C485.119 382.35 509.06 322.173 509.06 256.006C509.06 254.103 508.986 252.201 508.912 250.228H3.11946C3.11946 252.13 2.97168 254.033 2.97168 256.006C2.97168 322.173 26.9128 382.35 66.0018 427.447H446.03Z",
    fill: "url(#paint0_linear_98_6096)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.348 509.182C373 509.182 479.725 395.829 479.725 256.001C479.725 116.172 373 2.81934 241.348 2.81934C109.697 2.81934 2.97168 116.172 2.97168 256.001C2.97168 395.829 109.697 509.182 241.348 509.182Z",
    fill: "#F2B829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.332 512C108.252 512 0 397.142 0 256C0 114.858 108.252 0 241.332 0C374.412 0 482.665 114.858 482.665 256C482.665 397.142 374.412 512 241.332 512ZM241.332 5.63721C111.504 5.63721 5.91139 117.959 5.91139 256C5.91139 394.041 111.504 506.363 241.332 506.363C371.161 506.363 476.753 394.041 476.753 256C476.753 117.959 371.161 5.63721 241.332 5.63721Z",
    fill: "#FFED8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.732 211.96C221.324 211.819 221.841 211.678 222.432 211.537C226.274 210.48 230.191 209.423 233.959 208.366C309.773 187.72 387.36 175.459 465.464 169.751C432.286 72.3685 344.502 2.81934 241.348 2.81934C109.672 2.81934 2.97168 116.198 2.97168 256.001C2.97168 268.403 3.85839 280.593 5.48402 292.502C70.9526 254.028 149.352 231.479 220.732 211.96Z",
    fill: "url(#paint1_linear_98_6096)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.341 463.518C349.242 463.518 436.712 370.609 436.712 255.999C436.712 141.388 349.242 48.4785 241.341 48.4785C133.44 48.4785 45.9697 141.388 45.9697 255.999C45.9697 370.609 133.44 463.518 241.341 463.518Z",
    fill: "url(#paint2_linear_98_6096)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.803 452.824C349.112 452.824 432.051 364.71 432.051 256.015C432.051 147.321 349.112 59.2061 246.803 59.2061C144.493 59.2061 61.5547 147.321 61.5547 256.015C61.5547 364.71 144.493 452.824 246.803 452.824Z",
    fill: "#F2B829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.226 254.453C186.064 239.585 237.567 225.773 289.735 215.767C332.593 207.523 378.258 200.195 423.924 198.151C400.648 117.75 330.154 59.2642 246.804 59.2642C144.463 59.2642 61.5557 147.346 61.5557 256.073C61.5557 263.825 61.999 271.505 62.8857 279.045C86.6791 270.166 110.694 261.781 135.3 254.523L135.226 254.453Z",
    fill: "url(#paint3_linear_98_6096)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.412 447.251C271.693 447.251 262.604 447.11 253.885 446.616C245.904 446.194 237.998 442.741 231.348 448.448C227.875 451.478 226.766 455.706 229.5 459.652C235.559 468.32 247.234 465.853 256.693 464.585C267.112 463.176 274.87 459.864 283.368 454.227C286.989 451.76 284.328 447.251 280.486 447.251H280.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.506 6.20797C192.254 4.58727 188.708 3.3189 185.013 4.09402C181.171 4.9396 178.141 7.68774 178.658 11.7043C179.102 15.5094 182.722 18.1166 186.639 17.7643C190.998 17.4119 194.102 15.0866 196.984 12.1975C198.979 10.2245 197.649 7.19448 195.506 6.06704V6.20797Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_6096",
    x1: 277.777,
    y1: 432.873,
    x2: 254.362,
    y2: 231.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B15700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B15700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_98_6096",
    x1: 172.111,
    y1: 81.7403,
    x2: 307.988,
    y2: 431.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFCF51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFCF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_98_6096",
    x1: 232.252,
    y1: 207.73,
    x2: 265.609,
    y2: 402.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB7B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DD930C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E69A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F3BC32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_98_6096",
    x1: 162.197,
    y1: 69.6225,
    x2: 327.78,
    y2: 440.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFCF51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFCF00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_6096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCoins);
export default __webpack_public_path__ + "static/media/empty-coins.d80259639968a1bf8412a0d172d602f4.svg";
export { ForwardRef as ReactComponent };